import { useContext } from 'react';

import { createStateRouterContext } from '@components/StateRouter';

export const previewSlideoutRouterContext = createStateRouterContext();

export const usePreviewSlideoutNavigate = () => useContext(previewSlideoutRouterContext).pushPath;
